module.exports = __webpack_public_path__ + "img/newsImg12-11.b8192672.png";